import React, { FC } from 'react';
import { Container, makeStyles, Theme, Typography } from '@material-ui/core';
const useStyles = makeStyles((theme: Theme) => {
  return {
    h1: {
      margin: theme.spacing(9, 0, 8),
    },
    h2: {
      margin: theme.spacing(5, 0),
    },
    p: {
      marginBottom: theme.spacing(5),
      textAlign: 'left',
      [theme.breakpoints.up('md')]: {
        textAlign: 'justify',
      },
    },
    a: {
      color: theme.palette.primary.main,
      margin: theme.spacing(0, 1),
      fontStyle: 'italic',
    },
    ul: {
      margin: theme.spacing(7, 0),
      paddingLeft: 20,
      listStyle: 'circle',
      [theme.breakpoints.up('md')]: {
        textAlign: 'justify',
        paddingLeft: 40,
      },
    },
    li: {
      margin: theme.spacing(1, 0),
    },
  };
});
const TermsOfUse: FC = () => {
  const classes = useStyles();
  return (
    <Container maxWidth={false} fixed>
      <Typography className={classes.h1} variant="h1">
        <span>Terms and Conditions</span>
      </Typography>
      <Typography className={classes.p}>
        <span>Welcome to</span>
        <Typography
          component={'a'}
          href="https://silverlogistics-website.vercel.app/"
          className={classes.a}
          target={'_blank'}
          rel="noopener noreferrer"
        >
          https://silverglositics.net!
        </Typography>
      </Typography>

      <Typography className={classes.p}>
        These terms and conditions outline the rules and regulations for the use of Patron Trucking's Website, located at
        https://silverlogistics.net.
      </Typography>

      <Typography className={classes.p}>
        By accessing this website we assume you accept these terms and conditions. Do not continue to use silverglositics.net if
        you do not agree to take all of the terms and conditions stated on this page.
      </Typography>

      <Typography className={classes.p}>
        The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all
        Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company’s terms
        and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us",
        refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary
        to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting
        the Client’s needs in respect of provision of the Company’s stated services, in accordance with and subject to, prevailing
        law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she
        or they, are taken as interchangeable and therefore as referring to same.
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>Cookies</span>
      </Typography>

      <Typography className={classes.p}>
        We employ the use of cookies. By accessing silverglositics.net, you agreed to use cookies in agreement with the Silver
        Logistics's Privacy Policy.
      </Typography>

      <Typography className={classes.p}>
        Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by our
        website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our
        affiliate/advertising partners may also use cookies.
      </Typography>

      <Typography variant={'h2'} className={classes.h2}>
        <span>License</span>
      </Typography>

      <Typography className={classes.p}>
        Unless otherwise stated, Patron Trucking and/or its licensors own the intellectual property rights for all material on
        silverglositics.net. All intellectual property rights are reserved. You may access this from silverglositics.net for your
        own personal use subjected to restrictions set in these terms and conditions.
      </Typography>

      <Typography className={classes.p}>You must not:</Typography>
      <Typography component="ul" className={classes.ul}>
        <Typography component="li" className={classes.li}>
          Republish material from
          <Typography
            component={'a'}
            href="https://silverlogistics-website.vercel.app/"
            className={classes.a}
            target={'_blank'}
            rel="noopener noreferrer"
          >
            https://silverglositics.net!
          </Typography>
        </Typography>
        <Typography component="li" className={classes.li}>
          Sell, rent or sub-license material from silverglositics.net
        </Typography>
        <Typography component="li" className={classes.li}>
          Reproduce, duplicate or copy material from
          <Typography
            component={'a'}
            href="https://silverlogistics-website.vercel.app/"
            className={classes.a}
            target={'_blank'}
            rel="noopener noreferrer"
          >
            https://silverglositics.net!
          </Typography>
        </Typography>
        <Typography component="li" className={classes.li}>
          Redistribute content from
          <Typography
            component={'a'}
            href="https://silverlogistics-website.vercel.app/"
            className={classes.a}
            target={'_blank'}
            rel="noopener noreferrer"
          >
            https://silverglositics.net!
          </Typography>
        </Typography>
      </Typography>

      <Typography className={classes.p}>
        This Agreement shall begin on the date hereof. Our Terms and Conditions were created with the help of the{' '}
        <Typography
          component={'a'}
          href="https://www.termsandconditionsgenerator.com"
          target={'_blank'}
          rel="noopener noreferrer"
        >
          Terms And Conditions Generator
        </Typography>
        and the
        <Typography component={'a'} href="https://www.generateprivacypolicy.com" target={'_blank'} rel="noopener noreferrer">
          Privacy Policy Generator
        </Typography>
      </Typography>

      <Typography className={classes.p}>
        Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the
        website. Patron Trucking does not filter, edit, publish or review Comments prior to their presence on the website.
        Comments do not reflect the views and opinions of Patron Trucking,its agents and/or affiliates. Comments reflect the views
        and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Silver Logistics
        shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any
        use of and/or posting of and/or appearance of the Comments on this website.
      </Typography>

      <Typography className={classes.p}>
        Patron Trucking reserves the right to monitor all Comments and to remove any Comments which can be considered
        inappropriate, offensive or causes breach of these Terms and Conditions.
      </Typography>

      <Typography className={classes.p}>You warrant and represent that:</Typography>

      <Typography component="ul" className={classes.ul}>
        <Typography component="li" className={classes.li}>
          You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;
        </Typography>
        <Typography component="li" className={classes.li}>
          The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark
          of any third party;
        </Typography>
        <Typography component="li" className={classes.li}>
          The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an
          invasion of privacy
        </Typography>
        <Typography component="li" className={classes.li}>
          The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful
          activity.
        </Typography>
      </Typography>

      <Typography className={classes.p}>
        You hereby grant Patron Trucking a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce
        and edit any of your Comments in any and all forms, formats or media.
      </Typography>

      <Typography variant={'h2'} className={classes.h2}>
        <span>Hyperlinking to our Content</span>
      </Typography>

      <Typography className={classes.p}>
        The following organizations may link to our Website without prior written approval:
      </Typography>

      <Typography component="ul" className={classes.ul}>
        <Typography component="li" className={classes.li}>
          Government agencies;
        </Typography>
        <Typography component="li" className={classes.li}>
          Search engines;
        </Typography>
        <Typography component="li" className={classes.li}>
          News organizations;
        </Typography>
        <Typography component="li" className={classes.li}>
          Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other
          listed businesses; and
        </Typography>
        <Typography component="li" className={classes.li}>
          System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity
          fundraising groups which may not hyperlink to our Web site.
        </Typography>
      </Typography>

      <Typography className={classes.p}>
        These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is
        not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its
        products and/or services; and (c) fits within the context of the linking party’s site.
      </Typography>

      <Typography className={classes.p}>
        We may consider and approve other link requests from the following types of organizations:
      </Typography>

      <Typography component="ul" className={classes.ul}>
        <Typography component="li" className={classes.li}>
          commonly-known consumer and/or business information sources;
        </Typography>
        <Typography component="li" className={classes.li}>
          dot.com community sites;
        </Typography>
        <Typography component="li" className={classes.li}>
          associations or other groups representing charities;
        </Typography>
        <Typography component="li" className={classes.li}>
          online directory distributors;
        </Typography>
        <Typography component="li" className={classes.li}>
          internet portals;
        </Typography>
        <Typography component="li" className={classes.li}>
          accounting, law and consulting firms; and
        </Typography>
        <Typography component="li" className={classes.li}>
          educational institutions and trade associations.
        </Typography>
      </Typography>

      <Typography className={classes.p}>
        We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably
        to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the
        benefit to us from the visibility of the hyperlink compensates the absence of Patron Trucking; and (d) the link is in the
        context of general resource information.
      </Typography>

      <Typography className={classes.p}>
        These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely
        imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the
        context of the linking party’s site.
      </Typography>

      <Typography className={classes.p}>
        If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must
        inform us by sending an e-mail to Patron Trucking. Please include your name, your organization name, contact information
        as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs
        on our site to which you would like to link. Wait 2-3 weeks for a response.
      </Typography>

      <Typography className={classes.p}>Approved organizations may hyperlink to our Website as follows:</Typography>

      <Typography component="ul" className={classes.ul}>
        <Typography component="li" className={classes.li}>
          By use of our corporate name; or
        </Typography>
        <Typography component="li" className={classes.li}>
          By use of the uniform resource locator being linked to; or
        </Typography>
        <Typography component="li" className={classes.li}>
          By use of any other description of our Website being linked to that makes sense within the context and format of content
          on the linking party’s site.
        </Typography>
      </Typography>

      <Typography className={classes.p}>
        No use of Patron Trucking's logo or other artwork will be allowed for linking absent a trademark license agreement.
      </Typography>

      <Typography variant={'h2'} className={classes.h2}>
        <span>iFrames</span>
      </Typography>

      <Typography className={classes.p}>
        Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the
        visual presentation or appearance of our Website.
      </Typography>

      <Typography variant={'h2'} className={classes.h2}>
        <span>Content Liability</span>
      </Typography>

      <Typography className={classes.p}>
        We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against
        all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous,
        obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any
        third party rights.
      </Typography>

      <Typography variant={'h2'} className={classes.h2}>
        <span>Your Privacy</span>
      </Typography>

      <Typography className={classes.p}>Please read Privacy Policy</Typography>

      <Typography variant={'h2'} className={classes.h2}>
        <span>Reservation of Rights</span>
      </Typography>

      <Typography className={classes.p}>
        We reserve the right to request that you remove all links or any particular link to our Website. You approve to
        immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and
        it’s linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking
        terms and conditions.
      </Typography>

      <Typography variant={'h2'} className={classes.h2}>
        <span>Removal of links from our website</span>
      </Typography>

      <Typography className={classes.p}>
        If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We
        will consider requests to remove links but we are not obligated to or so or to respond to you directly.
      </Typography>

      <Typography className={classes.p}>
        We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do
        we promise to ensure that the website remains available or that the material on the website is kept up to date.
      </Typography>

      <Typography variant={'h2'} className={classes.h2}>
        <span>Disclaimer</span>
      </Typography>

      <Typography className={classes.p}>
        To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to
        our website and the use of this website. Nothing in this disclaimer will:
      </Typography>

      <Typography component="ul" className={classes.ul}>
        <Typography component="li" className={classes.li}>
          limit or exclude our or your liability for death or personal injury;
        </Typography>
        <Typography component="li" className={classes.li}>
          limit or exclude our or your liability for fraud or fraudulent misrepresentation;
        </Typography>
        <Typography component="li" className={classes.li}>
          limit any of our or your liabilities in any way that is not permitted under applicable law; or
        </Typography>
        <Typography component="li" className={classes.li}>
          exclude any of our or your liabilities that may not be excluded under applicable law.
        </Typography>
      </Typography>

      <Typography className={classes.p}>
        The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the
        preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in
        contract, in tort and for breach of statutory duty.
      </Typography>

      <Typography className={classes.p}>
        As long as the website and the information and services on the website are provided free of charge, we will not be liable
        for any loss or damage of any nature.
      </Typography>
    </Container>
  );
};

export default TermsOfUse;
